var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeacherFeedbackIcon = function SvgTeacherFeedbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h15l5 5V3a2 2 0 0 0-2-2H3zm2 11h9v2H5v-2zm0-4h14v2H5V8zm0-4h14v2H5V4z",
    fill: "#4EA15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5c-.414 0-.79.168-1.06.44A1.49 1.49 0 0 0 1.5 3v13c0 .414.168.79.44 1.06.27.272.646.44 1.06.44h15.207l4.293 4.293V3c0-.414-.168-.79-.44-1.06A1.495 1.495 0 0 0 21 1.5z",
    stroke: "#378142"
  })))));
};

export default SvgTeacherFeedbackIcon;